import { useState, useEffect } from "react";
import { useRequest } from "ahooks";
import { Space, Input, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import DepartmentTypeSelect from "@/components/common/DepartmentTypeSelect";
import DepartmentSelect from "@/components/common/DepartmentSelect";
import { message as messageService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";
import styles from "./index.module.less";

function BacklogMessage() {
  const [code, setCode] = useState();
  const [department, setDepartment] = useState();
  const [keyword, setKeyword] = useState();
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const auth = useAuthContext();
  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return messageService.listMyBacklogMessage(params, token);
    },
    {
      manual: true,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          department_type: code,
          department,
          keyword,
          page,
          page_size: pageSize,
        },
        auth.token
      );
    }
  }, [run, auth, code, department, keyword, page, pageSize]);

  const columns = [
    {
      title: "序号",
      width: 50,
      key: "num",
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "类型",
      key: "messageType",
      render: (record) => record.message?.type?.name,
    },
    {
      title: "上报单位",
      key: "department",
      render: (record) => record.message?.sender?.name,
    },
    {
      title: "标题",
      key: "title",
      render: (record) => (
        <Link
          to={`/workshop/mrece/detail/${record.message?.id}`}
          target="_blank"
        >
          {record.message?.title}
        </Link>
      ),
    },
    {
      title: "推送日期",
      dataIndex: "created_at",
    },
    {
      title: "待办人",
      key: "acceptor",
      render: (record) => record.acceptor?.username,
    },
    {
      title: "状态",
      key: "status_name",
      render: () => "未处理",
    },
  ];
  return (
    <div className={styles.backlogMessage}>
      <div className="table-toolbar">
        <div className="left"></div>
        <div className="right">
          <Space>
            <div>
              单位类型：
              <DepartmentTypeSelect value={code} onChange={setCode} />
            </div>
            <div>
              单位：
              <DepartmentSelect
                value={department}
                onChange={setDepartment}
                code={code}
              />
            </div>
            <div>
              标题：
              <Input
                prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                style={{ width: 220 }}
                placeholder="搜索内容"
                allowClear
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>
          </Space>
        </div>
      </div>
      <Table
        rowKey="id"
        size="middle"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={{
          pageSize: pageSize,
          total: data.count,
        }}
        onChange={({ current, pageSize }) => {
          setPage(current);
          setPageSize(pageSize);
        }}
      />
    </div>
  );
}

export default BacklogMessage;
